import { useNavigate, useParams } from 'react-router-dom';
import { DataBoxNewMessagePage } from '@gov-nx/component/web/DataBox/MessageForm/DataBoxNewMessagePage';
import type { DataBoxFolderType } from '@gov-nx/module/data-box/providers/DataBoxes.types';
import { DataBoxMessageFormProvider } from '@gov-nx/module/data-box/providers/MessageFormContext';
import { pageRouteResolver } from '@gov-nx/web/Router/routeResolver';

export const DataBoxNewMessage = () => {
	const { dataBoxId, folderType } = useParams();
	const navigate = useNavigate();

	const onMessageSent = () => {
		navigate(
			pageRouteResolver('datove-schranky.schranka', {
				dataBoxId,
				folderType,
			})
		);
	};

	return (
		<DataBoxMessageFormProvider
			dataBoxId={dataBoxId as string}
			folderType={folderType as DataBoxFolderType}
			onMessageSent={onMessageSent}
			onMessageCancelled={onMessageSent}
			isWeb>
			<DataBoxNewMessagePage />
		</DataBoxMessageFormProvider>
	);
};
